<div>
    <div class="flex" *ngIf="phases">
        <div class="full-width" *ngFor="let phase of phases; let i=index">
            <div class="transparent" [ngClass]="getGeneralStatusClass(phase.generalStatus, i)">
                .
            </div>
        </div>
    </div>
</div>